package one.devsbox.www.ui.locations.detail

import androidx.compose.foundation.text.input.TextFieldState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import compose.assets.Svg
import compose.assets.svg.DeleteOutline
import compose.assets.svg.EditOutline
import kotlinx.coroutines.launch
import one.devsbox.shared.ads.SharedIO
import one.devsbox.www.io.Repository
import one.devsbox.www.ui.widgets.ScreenContentAction
import one.devsbox.www.tools.ArgsId
import one.devsbox.www.ui.widgets.EntryViewMode
import one.devsbox.www.www_portal.generated.resources.*
import tk.mallumo.compose.navigation.navTo_DeviceDUI
import tk.mallumo.compose.navigation.navTo_LocationEUI
import tk.mallumo.compose.navigation.viewmodel.NavigationViewModel
import tk.mallumo.compose.navigation.viewmodel.VM
import tk.mallumo.utils.DataState

@VM
class LocationDVM : NavigationViewModel() {
    private lateinit var ctx: LocationDCtx

    var contentActions by mutableStateOf<List<ScreenContentAction>>(emptyList())
        private set

    data class Data(val location: SharedIO.Location)

    var state by mutableStateOf<DataState<Data>>(DataState.Loading())
        private set

    var search by mutableStateOf(TextFieldState())

    var showDeleteConfirmation by mutableStateOf(false)
    var showDeleteError by mutableStateOf(false)

    interface Action {
        fun edit(id: Long)
        fun delete()
        fun confirmDelete()
        fun dismissDeleteConfirmation()
        fun dismissDeleteError()
        fun openDetail(id: Long)
        fun back()
        fun reload()
    }

    val action = object : Action {

        override fun back() {
            ctx.nav.up()
        }

        override fun reload() {
            loadLocation(ctx.args.id)
        }

        override fun edit(id: Long) {
            ctx.nav.navTo_LocationEUI(ArgsId(id))
        }

        override fun delete() {
            showDeleteConfirmation = true
        }

        override fun dismissDeleteConfirmation() {
            showDeleteConfirmation = false
        }

        override fun dismissDeleteError() {
            showDeleteError = false
        }

        override fun confirmDelete() {
            showDeleteConfirmation = false
            state = DataState.Loading(state.entry)
            scope.launch {
                runCatching {
                    Repository.ads.location.delete(ctx.args.id)
                }.onFailure {
                    it.printStackTrace()
                    showDeleteError = true
                    state = DataState.Result(state.entry!!)
                }.onSuccess {
                    ctx.nav.up()
                }
            }
        }

        override fun openDetail(id: Long) {
            ctx.nav.navTo_DeviceDUI(ArgsId(id))
        }
    }

    fun setup(ctx: LocationDCtx) {
        this.ctx = ctx
        loadLocation(ctx.args.id)
    }

    private fun loadLocation(id: Long) {
        state = DataState.Loading()
        scope.launch {
            runCatching {
                Repository.ads.location.get(id)
            }.onSuccess {
                state = DataState.Result(Data(it))
            }.onFailure {
                state = DataState.Error(it.message ?: "Unknown error")
            }
            setupActions(state)
        }
    }

    private fun setupActions(result: DataState<Data>) {
        contentActions = result.entry?.location?.run {
            buildList {
                if (ctx.me.permission.location.write) {
                    add(
                        ScreenContentAction(
                            text = Res.string.ui_locations_detail_btn_edit,
                            color = ctx.colorSecondaryContainer,
                            icon = Svg.EditOutline
                        ) {
                            action.edit(ctx.args.id)
                        }
                    )
                }
                if (ctx.me.permission.location.delete && devices.isEmpty()) {
                    add(
                        ScreenContentAction(
                            text = Res.string.ui_locations_detail_btn_delete,
                            color = ctx.colorErrorContainer,
                            icon = Svg.DeleteOutline
                        ) {
                            action.delete()
                        }
                    )
                }
            }
        } ?: emptyList()
    }

    override fun onRelease() {}
}


